// 基础配置路由

const admin = {
    path: '/',
    component: resolve => require(['@/views/Layout/AdminLayout'], resolve),
    title: "layout",
    children: [
        // 配置导航
        {
            path: '/admin',
            component: resolve => require(['@/views/BaseConfigMana/BaseConfigMana'], resolve),
            name: 'admin',
            meta: { breadcrumb: [], role: 'admin', title: '首页' }
        },

        // 项目类型配置
        {
            path: '/projecttypesetting',
            component: resolve => require(['@/views/BaseConfigMana/ProjectTypeSetting/ProjectTypeSetting'], resolve),
            name: 'projecttypesetting',
            meta: { breadcrumb: [{ menu: 'projecttypesetting' }], role: 'admin', title: '项目配置' }
        },

        // 基础计费方案
        {
            path: '/chargeschemelist',
            component: resolve => require(['@/views/BaseConfigMana/SetBaseChargeScheme/ChargeSchemeList/ChargeSchemeList'], resolve),
            name: 'chargeschemelist',
            meta: { breadcrumb: [{ menu: 'chargeschemelist' }], role: 'admin', title: '计费方案'  }
        },
        // 添加计费方案或编辑
        {
            path: '/chargeschemelist/addchargescheme/:schemeId',
            component: resolve => require(['@/views/BaseConfigMana/SetBaseChargeScheme/AddChargeScheme/AddChargeScheme'], resolve),
            name: 'addchargescheme',
            meta: { title: '添加方案',  breadcrumb: [ { menu: 'chargeschemelist', path: "/chargeschemelist" }, { menu: 'addchargescheme' }], role: 'admin' }
        },

        // 账户管理
        {
            path: '/companyMana',
            component: resolve => require(['@/views/BaseConfigMana/CompanyMana/CompanyMana'], resolve),
            name: 'companyMana',
            meta: { title: '账户管理', breadcrumb: [ { menu: 'companyMana' }], role: 'admin'  }
        },

        // 权限模块
        {
            path: '/roleModule',
            component: resolve => require(['@/views/BaseConfigMana/RoleModule/RoleModule'], resolve),
            name: 'roleModule',
            meta: { title: '权限模块', breadcrumb: [ { menu: 'roleModule' }], role: 'admin' }
        },
        // 字典配置
        {
            path: '/dictionary',
            component: resolve => require(['@/views/BaseConfigMana/Dictionary/index'], resolve),
            name: 'dictionary',
            meta: { title: '字典配置', breadcrumb: [{ menu: 'dictionary' }], role: 'admin' }
        },
        // 系统配置
        {
            path: '/sysdic',
            component: resolve => require(['@/views/BaseConfigMana/SystemDic/index'], resolve),
            name: 'sysdic',
            meta: { title: '系统配置', breadcrumb: [{ menu: 'sysdic' }], role: 'admin' }
        },
    ]
};

export default admin